import { Select } from 'antd';
import React, { FunctionComponent } from 'react';
import cls from 'classnames';
import styles from './statusSelector.module.scss';
import { getTranslations } from '../../../features/translations/translationsUtils';

const { Option } = Select;

interface StatusSelectorProps {
  onChange: (coso: any) => void,
  value: ExtendedStatus | undefined,
}

export enum ExtendedStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
  All = 'all',
}

export const StatusSelect: FunctionComponent<StatusSelectorProps> = ({
  onChange,
  value
}) => {
  return (
    <Select
      defaultValue={ExtendedStatus.All}
      onChange={onChange}
      className={cls(styles.selector, styles.targeted)}
      dropdownClassName='madres'
      value={value}
    >
      <Option value={ExtendedStatus.All}>{getTranslations('REPORT_ALL')}</Option>
      <Option value={ExtendedStatus.Enabled}>{getTranslations('REPORT_ENABLED')}</Option>
      <Option value={ExtendedStatus.Disabled}>{getTranslations('REPORT_DISABLED')}</Option>
    </Select>
  );
}
